/**
 * What this bundle is, as the bundle itself can report it.
 *
 * `version.json` already answers "what did CI deploy" — it sits beside the bundle in
 * S3 and a `curl` reads it without loading the app. This answers the different
 * question that matters during support: *what is this browser actually running.* The
 * two disagree exactly when a stale bundle is cached, which is the case worth being
 * able to see.
 *
 * `VITE_APP_VERSION` has been set by the deploy since release versioning was added and
 * read by nothing, so the value CI computes has never reached the app. This is where it
 * arrives.
 *
 * Both fall back rather than throwing: a local `pnpm dev` build has neither, and the
 * fallbacks say so instead of implying a release.
 */
export const BUILD_INFO = {
  /** `<base-version>-<run-number>` from the deploy, or `dev` when built locally. */
  version: import.meta.env.VITE_APP_VERSION ?? "dev",
  /**
   * The commit the bundle was built from, or `local`.
   *
   * The version is the human label; this is what actually pins a build.
   * `GITHUB_RUN_NUMBER` is per-workflow, so it repeats across repos and resets if the
   * workflow file is renamed — the SHA does neither.
   */
  sha: import.meta.env.VITE_COMMIT_SHA ?? "local",
} as const;

/**
 * Publish the build onto `<html>`, so it is readable from devtools without asking the
 * user to run anything.
 *
 * An attribute rather than a console line: this survives a cleared console and adds no
 * noise to one. `version.json` remains the answer for "what is deployed"; this is the
 * answer for "what did *this* tab load".
 */
export function stampBuildInfo(): void {
  const root = document.documentElement;
  root.dataset.appVersion = BUILD_INFO.version;
  root.dataset.appSha = BUILD_INFO.sha;
}
